export default __webpack_public_path__ + "locales/sr-Cyrl-RS/Errors.json?hash=4b183f4d6f48595eeae851744aa2a471";